import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import ReactTable from '../../../components/ReactTable';
import { IoClose } from 'react-icons/io5';
import { FiCheck, FiEye, FiLoader } from 'react-icons/fi'; // Import FiLoader for the spinner
import { createColumnHelper } from '@tanstack/react-table';
import { CiEdit } from 'react-icons/ci';
import { GoTrash } from "react-icons/go";
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

function TrainingTitlePage() {
  const navigate = useNavigate();
  const [LearningVideoList, setLearningVideoList] = useState([]);
  const [loading, setLoading] = useState(false); // To track loading state
  const [searchQuery, setSearchQuery] = useState('');
  const [showEntries, setShowEntries] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);  // State for modal visibility
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false); // State for delete confirmation modal
  const [categoryToDelete, setCategoryToDelete] = useState(null); // State to store the category to delete
  const [newCategory, setNewCategory] = useState({ title: '' });  // State for new category form
  const [editCategory, setEditCategory] = useState(null); // State to handle editing
  const [selectedFile, setSelectedFile] = useState(null);


  // Get the token from the Redux store
  const { token,authToken } = useSelector((state) => state.login);

  console.log("editCategory",editCategory)

  const columnHelper = createColumnHelper();

  const base = `${process.env.REACT_APP_BASE_URL}/${process.env.REACT_APP_API_TYPE}`;

  // Fetch LearningVideoList from the API with pagination
  const fetchLearningVideoTitleList = async (page = 1, limit = 10, query = '') => {
    setLoading(true); // Set loading to true before API call
    try {
      const response = await axios.get(`${base}/learningVideos`, {
        headers: {
          'Authorization': `Bearer ${authToken}`,  // Add the token to the request header
        },
      });

      setLearningVideoList(response?.data?.data?.list);
      setTotalPages(response.data.totalPages);  // Set total pages from the response
    } catch (error) {
      console.error('Error fetching bonds:', error);
    } finally {
      setLoading(false); // Set loading to false after the API call is complete
    }
  };

  // Handle new category form input change
  const handleCategoryInputChange = (e) => {
    const { name, value } = e.target;
    setNewCategory((prev) => ({ ...prev, [name]: value }));
  };

  // Handle new category form submission
 const handleCreateCategory = async () => {
  if (newCategory.title === "") {
    toast.info("Please add Category title");
    return;
  }
  
  setLoading(true)
  try {
    const data={
      name:newCategory.title
    }
    

    await axios.post(`${base}/learningVideos`, data, {
      headers: {
        Authorization: `Bearer ${authToken}`,
       
      },
    });
    toast.success("Learning video title added")
    fetchLearningVideoTitleList();

    setIsModalOpen(false);
    setNewCategory({ title: "" });
    setSelectedFile(null);
    
  } catch (error) {
    toast.error(error.response.data.message)
    console.error("Error creating category:", error);
  }finally{

    setLoading(false)
  }
};


  // Handle delete category click
  const handleDeletecategory = async () => {
     setLoading(true)
    try {
      if (categoryToDelete) {
        await axios.delete(`${base}/learningVideos/${categoryToDelete}`, {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });
        fetchLearningVideoTitleList();
        setIsDeleteModalOpen(false); // Close delete confirmation modal
        setCategoryToDelete(null); // Reset the category to delete
      }
      toast.success("Learning Video title deleted")
    } catch (error) {
      toast.error(error.response.data.message|| "Something went wrong please try again!")
      // console.error('Error deleting category:', error);
    } finally{

      setLoading(false)
    }
  };

  // Handle edit category click (open edit modal)
  const handleEditCategory = (category) => {
    console.log("category",category)
    setEditCategory(category);
    setIsModalOpen(true); // Open modal to edit category
  };

  // Handle category edit input change
  const handleEditCategoryInputChange = (e) => {
    const { name, value } = e.target;
    setEditCategory((prev) => ({ ...prev, "name": value }));
  };

  // Handle category edit form submission
  const handleEditCategorySubmit = async () => {
  if (editCategory.name === "") {
    toast.info("Please add Learning video title");
    return;
  }
  
   setLoading(true)
  try {
    

    await axios.put(`${base}/learningVideos/${editCategory.id}`, {name:editCategory?.name}, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });

    fetchLearningVideoTitleList();
    setIsModalOpen(false);
    setEditCategory(null);
    setSelectedFile(null);
    toast.success("Learning video title edit successful")
  } catch (error) {
    toast.error(error.response.data.message|| "Something went wrong please try again!")
    // console.error("Error editing category:", error);
  } finally{
     setLoading(false)
  }
};


  // Reset the modal form when closed
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setNewCategory({ title: '' }); // Reset the new category data
    setEditCategory(null); // Reset the edit category data
  };

  useEffect(() => {
    fetchLearningVideoTitleList(currentPage, showEntries, searchQuery);  // Fetch LearningVideoList when component mounts
  }, [currentPage, showEntries, searchQuery]);

  const hostedcolumns = [
    columnHelper.accessor((row) => row.name, {
      id: 'categoryTitle', // Unique ID for this column
      cell: (info) => info.renderValue(),
      header: () => <span>Name</span>,
    }),
//     columnHelper.accessor((row) => row.docUrl, {
//   id: 'docUrl',
//   cell: (info) => {
//     const url = info.getValue();
//     return url ? (
//       <a href={url} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">
//         View File
//       </a>
//     ) : (
//       "No File"
//     );
//   },
//   header: () => <span>Document</span>,
// }),
    columnHelper.accessor((row) => row, {
      id: 'action',
      cell: (info) => {
        const category = info?.row?.original;

        return (
          <div className="flex justify-end gap-5">
            <span className='cursor-pointer' onClick={(e) => handleNavigate(category.id)}>
              <FiEye />
            </span>
            <span className='cursor-pointer' onClick={() => handleEditCategory(category)}>
              <CiEdit />
            </span>
            <span className='cursor-pointer' onClick={() => { setCategoryToDelete(category.id); setIsDeleteModalOpen(true); }}>
              <GoTrash />
            </span>
          </div>
        );
      },
      header: () => (
        <div className="flex justify-end">
          <span>Action</span>
        </div>
      ),
    }),
  ];

  const handleNavigate = (id) => {
    navigate(`/manage-resource/training/learning/${id}`)
  }

  const handleClearAll=()=>{
    setEditCategory("")
    setSelectedFile("")
  }
  const handleDeleteFile=()=>{
    setEditCategory({name:editCategory?.name,id:editCategory.id})
  }

  // Loader Component using React Icons FiLoader
  const Loader = () => (
    <div className="flex justify-center items-center">
      <FiLoader className="animate-spin text-4xl text-blue-600" />
    </div>
  );

  return (
    <div className="p-6 bg-gray-50 rounded-lg mt-[50px]">
      <div className="flex justify-between mb-6">
        <h2 className="text-2xl font-semibold text-gray-800">Learning Video Category List</h2>
        <div className="flex items-center space-x-2">
          <button
            onClick={() => {handleClearAll(); setIsModalOpen(true)}} // Open modal for creating new category
            className="bg-[#065697] text-white p-3 rounded-md transition"
          >
            Add Category Title
          </button>
        </div>
      </div>

      {/* Show Loader when loading is true */}
      {loading ? (
        <Loader />
      ) : (
        <div>
          {/* Table rendering */}
          {LearningVideoList?.length > 0 && (
            <ReactTable key={JSON.stringify(LearningVideoList)} defaultData={LearningVideoList} columns={hostedcolumns} />
          )}
        </div>
      )}

      {/* New Category Modal */}
      {(isModalOpen || editCategory) && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center">
          <div className="bg-white p-6 rounded-lg w-1/3">
            <div className="flex justify-between items-center">
              <h3 className="text-xl font-semibold">
                {editCategory ? 'Edit Learning Video Title' : 'Learning Video Title'}
              </h3>
              <IoClose
                className="cursor-pointer"
                onClick={handleCloseModal} // Close modal and reset form
              />
            </div>
           <div className="mt-4 space-y-4">
              <input
                type="text"
                name="title"
                value={editCategory ? editCategory.name : newCategory.title}
                onChange={editCategory ? handleEditCategoryInputChange : handleCategoryInputChange}
                placeholder="Learning Video Title"
                className="p-3 border rounded-md w-full"
              />

             
              
             
            </div>

            <div className="mt-4 flex justify-end">
              <button
                onClick={editCategory ? handleEditCategorySubmit : handleCreateCategory}
                disabled={loading} // Disable the button during loading
                className={`bg-[#065697] text-white p-3 rounded-md transition ${loading && `cursor-not-allowed`}`}
              >
                {editCategory ? 'Update' : 'Create'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {isDeleteModalOpen && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center">
          <div onClick={() => setIsDeleteModalOpen(false)} className="bg-white p-6 rounded-lg w-1/3">
            <h3 className="text-xl font-semibold">Are you sure you want to delete this category?</h3>
            <div className="mt-4 flex justify-end gap-4">
              <button
                onClick={() => setIsDeleteModalOpen(false)}
                className="bg-gray-300 text-black p-2 rounded-md"
              >
                Cancel
              </button>
              <button
                onClick={handleDeletecategory}
                disabled={loading} // Disable the button during loading
                className="bg-red-600 text-white p-2 rounded-md"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default TrainingTitlePage;
